import React, { Component } from 'react';
import { Pagination, message, Spin } from 'antd';
import TableC from '../../basicElement/TableC';
import ContractTable from './components/ContractTable';
import isEmptyObject from '../../shared/isEmptyObject';
import format from '../../shared/format';
import API_URL from '../../../common/url';
import Fetch from '../../../common/Fetch';

class DoubleHeader extends Component {
    state = {
        data: [],
        heads:{},
        investigation: null,
    }

    componentDidMount() {
        this.queryHead();
    }

    componentDidUpdate(prevProps) {
        const { loadHead, loadData } = this.props;
        if (prevProps.loadHead !== loadHead) {
            this.queryHead();
        }
        if (prevProps.loadData !== loadData) {
            this.loadData();
        }
    }

    queryHead = () => {
        const { changeLoading } = this.props;
        changeLoading(true);
        Fetch.post(API_URL.common.queryUserCustomDisplayByUserId, {
            type: 'CASH_REQ_MULTI_CONTRACT,CASH_REQ_MULTI_APPLICATION'
        }).then(res => {
            changeLoading(false);
            this.setState({ heads: res }, () => {
                this.loadData();
            });
        }).catch(error => {
            console.error(error);
            changeLoading(false);
        });
    }

    loadData = () => {
        const { invId } = sessionStorage;
        const { searchParams, changeLoading, changeAddable, sortParams, pagination, onChange } = this.props;
        const { remittanceNum, paymentProgressIds = [] } = searchParams;
        const { current, pageSize } = pagination;
        changeLoading(true);
        Fetch.post(API_URL.contract.queryApplicationMultiHead, {
            offset: current,
            limit: pageSize,
            ...sortParams,
            ...searchParams,
            paymentProgressIds: paymentProgressIds.join(','),
            curInvId: invId,
            remittanceNum: (remittanceNum || remittanceNum === 0) ? `第${remittanceNum}笔` : '',
            type: 'CASH_REQ_MULTI_CONTRACT',
        }).then(res => {
            const { data: { datas, totalCount }, isAdd } = res;
            const { childList, ...investigation } = datas[0] || {};
            pagination.total = totalCount;
            changeLoading(false);
            changeAddable(isAdd);
            onChange({ pagination });
            this.setState({
                investigation,
                data: childList || [],
            });
        }).catch(error => {
            console.error(error);
            changeLoading(false);
        });
    }

    handleStick = (record) => {
        const { changeLoading } = this.props
        const { sortIndex, contractRemittanceApplicationId } = record;
        const url = sortIndex ? API_URL.contract.cancelToppingContractRemittanceApplication : API_URL.contract.toppingContractRemittanceApplication;
        changeLoading(true);
        Fetch.post(url, {
            contractRemittanceApplicationId,
        }).then(res => {
            message.success(res.success);
            changeLoading(false);
            this.loadData();
        }).catch(error => {
            console.error(error);
            changeLoading(false);
        });
    }

    getColumns = () => {
        const { resolveUserList } = this.props;
        const columns = [{
                title: 'JDE主项目号',
                dataIndex: 'investigationJdeContractMainCode',
                key: 'investigationJdeContractMainCode',
                fixed: 'left',
                width: 100,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 160,
            },{
                title: '项目阶段',
                dataIndex: 'invStageName',
                key: 'invStageName',
                width: 160,
            },  {
                title: '项目领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 100,
            }, {
                title: '疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 80,
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: 'PM',
                dataIndex: 'pm',
                key: 'pm',
                width: 120,
                render: (text, record) => {
                    const { pmUserList } = record;
                    return resolveUserList(pmUserList, 'PM');
                },
            }, {
                title: '例数',
                dataIndex: 'randomAmount',
                key: 'randomAmount',
                width: 80,
            }, {
                title: '访视数',
                dataIndex: 'visitAmount',
                key: 'visitAmount',
                width: 80,
            }, {
                title: '申办方',
                dataIndex: 'investigationSponsor',
                key: 'investigationSponsor',
                width: 160,
            }, {
                title: 'BD',
                dataIndex: 'bd',
                key: 'bd',
                width: 120,
                render: (text, record) => {
                    const { bdUserList } = record;
                    return resolveUserList(bdUserList, 'BD');
                },
            }, {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
                width: 100,
            }, {
                title: '项目总金额/人民币',
                dataIndex: 'jdeContractAmount',
                key: 'jdeContractAmount',
                width: 140,
                render: text => format('money', text)
            }, {
                title: '已开票总金额/人民币',
                dataIndex: 'grossAmount',
                key: 'grossAmount',
                width: 140,
                render: text => format('money', text)
            }, {
                title: '已回款总金额/人民币',
                dataIndex: 'receivingAmount',
                key: 'receivingAmount',
                width: 140,
                render: text => format('money', text)
            }, {
                title: '项目关闭申请情况',
                dataIndex: 'remittanceCompletedInfoShow',
                key: 'remittanceCompletedInfoShow',
                width: 120,
            }, {
                title: 'PM确认已到达milestone但未请款金额/人民币',
                dataIndex: 'notApplyAmount',
                key: 'notApplyAmount',
                width: 160,
                render: text => format('money', text)
            }
        ];
        return columns;
    }

    handlePaginationChange = page => {
        const { pagination, onChange } = this.props;
        pagination.current = page;
        onChange({ pagination }, true);
    }

    render() {
        const { loading, pagination, ...rest } = this.props;
        const { heads, data, investigation } = this.state;
        const proData = (!investigation || isEmptyObject(investigation)) ? [] : [investigation];
        return (
            <Spin spinning={loading}>
                <TableC
                    data={proData}
                    columns={this.getColumns()}
                    rowKey="investigationId"
                />
                {
                    (data || []).map(i => {
                        return (
                            <div
                                key={i.investigationJdeContractId}
                                className="table-align-center"
                                style={{ marginTop: 20 }}
                            >
                                <ContractTable
                                    data={i}
                                    heads={heads}
                                    handleStick={this.handleStick}
                                    {...rest}
                                />
                            </div>
                        );
                    })
                }
                <Pagination
                    style={{ marginTop: 20, float: 'right' }}
                    onChange={this.handlePaginationChange}
                    {...pagination}
                />
            </Spin>
        );
    }
}

export default DoubleHeader;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/DoubleHeader.js